import "./App.css";
import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import HomePage from "./pages/home/HomePage";
import FileClaimPage from "./pages/fileClaim/FileClaimPage";
import AboutPage from "./pages/about/AboutPage";
import FaqPage from "./pages/faq/FaqPage";
import ContactPage from "./pages/contact/ContactPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import IndividualClaim from "./pages/dashboard/IndividualClaim";
import DisclaimerPage from "./pages/disclaimer/DisclaimerPage";
import ClaimStatus from "./pages/dashboard/ClaimStatus";
import FileaClaim from "./pages/fileClaim/FileaClaim";
import StartFileClaim from "./pages/fileClaim/StartFileClaim";
import RegisterPage from "./pages/authPages/RegisterPage";
import LoginPage from "./pages/authPages/LoginPage";
import ForgotPassword from "./pages/authPages/ForgotPassword";
import CreateNewPassword from "./pages/authPages/CreateNewPassword";
import AccountSettings from "./pages/PersonalInfoAndNofification/AccountSettings";
import ScrollToTop from "./components/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import PageNotFound from "./pages/pageNotFound/PageNotFound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivacyPolicyPage from "./pages/disclaimer/PrivacyPolicyPage";
import ReviewPage from "./pages/reviews/ReviewPage";
import FlightTracking from "./pages/histroricFlights/FlightTracking";
import FlightWeather from "./pages/flightWeather/FlightWeather.jsx";
import FlightLiveTracking from "./pages/FlightTracking/FlightLiveTracking.jsx";
import FlightMap from "./pages/FlightTracking/FlightMap.jsx";
import DelayStatistics from "./pages/DelayStatistics/DelayStatistics.jsx";
import FlightStatsDetails from "./pages/histroricFlights/FlightStatsDetails.jsx";
import DraftListPage from "./pages/dashboard/DraftListPage.jsx";
import DraftClaimStatus from "./pages/dashboard/DraftClaimStatus.jsx";
import GroupClaim from "./pages/groupClaim/GroupClaim.jsx";

const App = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  // useEffect(() => {
  //   localStorage.clear()
  // },[])


  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnHover
        style={{ zIndex: 9999 }}
      />
      <ScrollToTop />
      {!user ? (
        <Routes>
          <Route element={<HomePage />} path="/" />
          <Route element={<FileaClaim />} path="/file-claim" />
          <Route element={<GroupClaim />} path="/start-group-claim" />
          <Route element={<StartFileClaim />} path="/start-your-claim" />
          <Route element={<ClaimStatus />} path="/claimstatus" />
          <Route element={<DraftClaimStatus />} path="/draft-claim-status" />
          <Route element={<AboutPage />} path="/about-us" />
          <Route element={<FaqPage />} path="/faq" />
          <Route element={<ContactPage />} path="/contact-us" />
          <Route element={<DisclaimerPage />} path="/disclaimer" />
          <Route element={<PrivacyPolicyPage />} path="/privacy" />
          <Route element={<ReviewPage />} path="/review" />

          <Route element={<RegisterPage />} path="/register" />
          <Route element={<LoginPage />} path="/login" />
          <Route element={<ForgotPassword />} path="/login/forgot-password" />
          <Route
            element={<CreateNewPassword />}
            path="/login/new-password/:token/:email"
          />
          <Route element={<FlightTracking />} path="/historic-data" />
          <Route element={<FlightWeather />} path="/check-weather" />
          <Route element={<FlightLiveTracking />} path="/flight-tracking" />
          <Route element={<DelayStatistics />} path="/delay-statistics" />

          <Route element={<IndividualClaim />} path="/view-claim/:claim_id" />
          <Route element={<FileaClaim />} path="/edit-claim/:claim_id" />
          <Route path="*" element={<PageNotFound />} />
          <Route element={<DashboardPage />} path="/dashboard" />
          <Route element={<FlightStatsDetails />} path="/flight-live-tracking" />
          <Route element={<DraftListPage />} path="/drafts" />


        </Routes>
      ) : (
        <Routes>
          <Route element={<HomePage />} path="/" />
          <Route element={<FileaClaim />} path="/file-claim" />
          <Route element={<StartFileClaim />} path="/start-your-claim" />
          <Route element={<GroupClaim />} path="/start-group-claim" />

          <Route element={<ClaimStatus />} path="/claimstatus" />
          <Route element={<DraftClaimStatus />} path="/draft-claim-status" />

          <Route element={<AboutPage />} path="/about-us" />
          <Route element={<FaqPage />} path="/faq" />
          <Route element={<ReviewPage />} path="/review" />
          <Route element={<FlightTracking />} path="/historic-data" />
          <Route element={<FlightLiveTracking />} path="/flight-tracking" />
          <Route element={<DelayStatistics />} path="/delay-statistics" />
          <Route element={<FlightStatsDetails />} path="/flight-live-tracking" />

          <Route element={<ContactPage />} path="/contact-us" />
          <Route element={<FlightWeather />} path="/check-weather" />
          <Route element={<DisclaimerPage />} path="/disclaimer" />
          <Route element={<PrivacyPolicyPage />} path="/privacy" />
          <Route element={<DraftListPage />} path="/drafts" />
          <Route element={<ForgotPassword />} path="/login/forgot-password" />

          <Route
            element={<CreateNewPassword />}
            path="/login/new-password/:token/:email"
          />
          <Route element={<AccountSettings />} path="/account-settings" />
          <Route element={<DashboardPage />} path="/dashboard" />
          <Route element={<IndividualClaim />} path="/view-claim/:claim_id" />
          <Route element={<FileaClaim />} path="/edit-claim/:claim_id" />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      )}
    </>
  );
};

export default App;
